<template>
  <div>
    <Modal :onClose="onClose" class="modal-dark">
      <div slot="header">{{$t('capture.chooseChannel.title')}}</div>
      <form>
        <div class="form-detail">
          <div class="row">
            <div class="col-md-12">
              <div class="section-channel-browser">
                <div class="list-group list-group-dark">
                  <div class="list-item list-item-choices"
                    v-for="(channel, index) in channels"
                    :key="index"
                    :class="{'active': isChosen(channel)}"
                    @click="onChoose(channel)">
                    <div class="list-item-content list-item-primary">
                      <div class="title">{{channel.name}}</div>
                      <div class="sub-title">
                        <a href="#">{{channel.description}}</a>
                      </div>
                    </div>
                    <div class="list-item-actions">
                      <div class="checkbox-round">
                        <input type="checkbox" id="checkbox" :checked="isChosen(channel)"/>
                        <label for="checkbox"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash';
import { getDateTime } from '@/utils';
import Modal from '@/components/elements/Modal.vue';

export default {
  props: ['onClose', 'onSubmit', 'channels', 'currentChannel'],
  components: {
    Modal,
  },
  data() {
    return {
      selectedChannel: null,
    };
  },
  created() {
    this.selectedChannel = _.cloneDeep(this.currentChannel);
  },
  methods: {
    getDateTime,
    isChosen(item) {
      // eslint-disable-next-line no-underscore-dangle
      return this.selectedChannel._id === item._id;
    },
    onChoose(item) {
      this.onSubmit(item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.list-group-dark {
  .list-item-choices {
    background-color: $primary-background;
    border-color: transparent;
    border-radius: 4px;
    transition: background-color 250ms ease;
    .list-item-actions {
      padding-right: 1.5rem;
    }
    &:hover {
      background-color: $primary-darker;
    }
    &.active {
      background: $btn-primary;
    }
  }
}

</style>
